export { default as translations } from './translations.json';
export const MAX_WAITLIST = 500;

/**
 * Get stock waitlist from listing.
 * @param {Object|null} listing
 * @returns {Object[]}
 */
export const getStockWaitlist = (listing) =>
  listing?.attributes?.metadata?.stockWaitlist || [];

/**
 * Check if user is on the waitlist.
 * @param {Object[]} waitlist
 * @param {string} email
 * @returns {boolean}
 */
export const isOnWaitlist = (waitlist, email) =>
  Array.isArray(waitlist) && waitlist.some(e => e.email === email);
